const resolvers = {};

export default resolvers;
